// extracted by mini-css-extract-plugin
export var bubble = "_3b-0";
export var container = "_3b-3";
export var contrastBorder = "_3b-4";
export var greyOut = "_3b-2";
export var initialsWrapper = "_3b-1";
export var large = "_3b-9";
export var medium = "_3b-8";
export var mediumSmall = "_3b-7";
export var mediumSmallMedium = "_3b-c";
export var micro = "_3b-5";
export var small = "_3b-6";
export var tiny = "_3b-b";
export var xTiny = "_3b-a";